"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HelpHint = _interopRequireDefault(require("../tooltips/HelpHint"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Utils = _interopRequireDefault(require("../../util/Utils"));

/**
 * @class LabelValuePairs
 * @desc list form of data
 *
 * @param {array} dataPairs
 *          an array of strings to define label and value for each item in the list.
 * @param {string} [data-id="label-display"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *      css parameter
 * @param {boolean} [pruneEmpty=false]
 *      When true, empty values will not be listed at all.
 * @example <LabelValuePairs data=id="label-display" />
 */

/**
 * @typedef {object} LabelValuePairs#Row
 * @desc An object describing a leaf in the LeftNav
 * @property {string} label
 *              The label (left column)
 * @property {node} value
 *              The value (right column)
 * @property {string} hintText
 *              Optional contents of a help hint on the value
 * @property {boolean} divider
 *              If set to true, this row is a divider line
 * @property {string} title
 *              If defined, this row is a title
 */
var pruneEmptyPairs = function pruneEmptyPairs(dataPairs) {
  return (0, _filter.default)(dataPairs).call(dataPairs, function (pair) {
    return !!pair.value || pair.value === 0;
  });
};

var renderLabel = function renderLabel(_ref, dividerIndex) {
  var label = _ref.label,
      value = _ref.value,
      hintText = _ref.hintText,
      hintPlacement = _ref.hintPlacement,
      hintLink = _ref.hintLink,
      divider = _ref.divider,
      title = _ref.title;
  // IE doesn't support css grid, so we render a table instead
  var Tag = _Utils.default.isIE() ? "td" : "div";

  var renderHint = function renderHint() {
    return hintText && /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
      className: "inline label-value-pairs__help-hint",
      hintText: hintText,
      hintPlacement: hintPlacement,
      hintLink: hintLink
    });
  };

  if (divider) {
    var HRTag = _Utils.default.isIE() ? "td" : "hr";
    return /*#__PURE__*/_react.default.createElement(HRTag, {
      key: dividerIndex,
      colSpan: "2",
      className: "label-value-pairs__divider"
    });
  } else if (title) {
    return /*#__PURE__*/_react.default.createElement(Tag, {
      key: title,
      className: "label-value-pairs__title",
      colSpan: "2"
    }, title, renderHint());
  } else {
    var _context, _context2, _context3, _context4;

    return [/*#__PURE__*/_react.default.createElement(Tag, {
      key: (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(label, "-")).call(_context2, value, "-")).call(_context, dividerIndex),
      className: "label-value-pairs__label"
    }, label), /*#__PURE__*/_react.default.createElement(Tag, {
      key: (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(value, "-")).call(_context4, label, "-")).call(_context3, dividerIndex),
      className: "label-value-pairs__value"
    }, value, renderHint())];
  }
};

var LabelValuePairs = function LabelValuePairs(_ref2) {
  var _context5;

  var className = _ref2.className,
      dataPairs = _ref2.dataPairs,
      dataId = _ref2["data-id"],
      pruneEmpty = _ref2.pruneEmpty;
  var Tag = _Utils.default.isIE() ? "table" : "div";
  return /*#__PURE__*/_react.default.createElement(Tag, {
    "data-id": dataId,
    className: (0, _classnames.default)("label-value-pairs", className)
  }, (0, _map.default)(_context5 = pruneEmpty ? pruneEmptyPairs(dataPairs) : dataPairs).call(_context5, _Utils.default.isIE() ? function (item) {
    return /*#__PURE__*/_react.default.createElement("tr", null, renderLabel(item));
  } : renderLabel));
};

LabelValuePairs.defaultProps = {
  "data-id": "label-value-pairs",
  pruneEmpty: false
};
LabelValuePairs.propTypes = {
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  dataPairs: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.node,
    hintText: _propTypes.default.string,
    hintPlacement: _propTypes.default.string,
    hintLink: _propTypes.default.string
  }), _propTypes.default.shape({
    divider: _propTypes.default.bool.isRequired
  }), _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    hintText: _propTypes.default.string,
    hintPlacement: _propTypes.default.string,
    hintLink: _propTypes.default.string
  })])).isRequired,
  pruneEmpty: _propTypes.default.bool
};
module.exports = LabelValuePairs;